export function assertNever(obj: never, message: string): never {
  console.error('Never failure', obj);
  throw new Error(message);
}
